package com.sweetlime.bingeamigo.presentation.features.auth

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import bingeamigo.composeapp.generated.resources.Res
import bingeamigo.composeapp.generated.resources.binge_amigo_logo
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.presentation.navigation.MainScreen
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.koinInject

data class EmailVerificationScreen(val email: String) : Screen {

    @Composable
    override fun Content() {

        val navigator = LocalNavigator.currentOrThrow
        val viewModel: EmailVerificationViewModel = koinInject()
        val state by viewModel.state.collectAsState()

        LaunchedEffect(Unit) {
            viewModel.startPolling()
        }

        LaunchedEffect(state) {
            if (state is EmailVerificationViewModel.State.Verified) {
                navigator.replace(MainScreen)
            }
        }

        Column(
            modifier = Modifier
                .fillMaxSize()
                .background(BrandColors.Background)
                .padding(horizontal = 32.dp),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Image(
                painter = painterResource(Res.drawable.binge_amigo_logo),
                contentDescription = "BingeAmigo",
                modifier = Modifier.size(96.dp)
            )

            Spacer(modifier = Modifier.height(32.dp))

            Text(
                text = "Check your inbox",
                style = MaterialTheme.typography.headlineSmall,
                color = BrandColors.TextPrimary,
                fontWeight = FontWeight.Bold
            )

            Spacer(modifier = Modifier.height(12.dp))

            Text(
                text = "We sent a verification link to",
                style = MaterialTheme.typography.bodyMedium,
                color = BrandColors.TextSecondary,
                textAlign = TextAlign.Center
            )

            Text(
                text = email,
                style = MaterialTheme.typography.bodyMedium,
                color = BrandColors.Primary,
                fontWeight = FontWeight.SemiBold,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(8.dp))

            Text(
                text = "Once confirmed, you'll be signed in automatically.",
                style = MaterialTheme.typography.bodySmall,
                color = BrandColors.TextSecondary,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(40.dp))

            Button(
                onClick = { viewModel.checkNow() },
                modifier = Modifier
                    .fillMaxWidth()
                    .height(56.dp),
                shape = RoundedCornerShape(16.dp),
                colors = ButtonDefaults.buttonColors(
                    containerColor = BrandColors.Primary
                )
            ) {
                Text(
                    text = "Already confirmed?",
                    color = Color.Black,
                    fontWeight = FontWeight.Bold
                )
            }

            if (state is EmailVerificationViewModel.State.ManualCheckFailed) {
                Spacer(modifier = Modifier.height(16.dp))
                Text(
                    text = (state as EmailVerificationViewModel.State.ManualCheckFailed).message,
                    style = MaterialTheme.typography.bodySmall,
                    color = BrandColors.Error,
                    textAlign = TextAlign.Center
                )
            }
        }
    }
}